export const techSpecialists = [
  {
    name: 'Vue.js',
    groupTitle: 'Front-end',
    groupType: 'frontend',
    tooltipHint: true,
  },
  {
    name: 'Angular',
    groupTitle: 'Front-end',
    groupType: 'frontend',
  },
  {
    name: 'React.js',
    groupTitle: 'Front-end',
    groupType: 'frontend',
  },
  {
    name: 'JavaScript',
    groupTitle: 'Front-end',
    groupType: 'frontend',
    tooltipHint: true,
  },
  {
    name: '.NET',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Java',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Python',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Scala',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Ruby',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Rust',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'C++',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Node.js',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Golang',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'PHP',
    groupTitle: 'Back-end',
    groupType: 'backend',
  },
  {
    name: 'Android',
    groupTitle: 'Mobile',
    groupType: 'mobile',
  },
  {
    name: 'React Native',
    groupTitle: 'Mobile',
    groupType: 'mobile',
  },
  {
    name: 'iOS',
    groupTitle: 'Mobile',
    groupType: 'mobile',
  },
  {
    name: 'Xamarin',
    groupTitle: 'Mobile',
    groupType: 'mobile',
  },
  {
    name: 'Ionic',
    groupTitle: 'Mobile',
    groupType: 'mobile',
  },
  {
    name: 'Flutter',
    groupTitle: 'Mobile',
    groupType: 'mobile',
  },
  { name: 'PostgreSQL', groupTitle: 'Database', groupType: 'database' },
  { name: 'MySQL', groupTitle: 'Database', groupType: 'database' },
  {
    name: 'Oracle',
    groupTitle: 'Database',
    groupType: 'database',
  },
  { name: 'Microsoft Azure SQL Database', groupTitle: 'Database', groupType: 'database' },
  {
    name: 'MsSQL',
    groupTitle: 'Database',
    groupType: 'database',
  },
  {
    name: 'NoSQL',
    groupTitle: 'Database',
    groupType: 'database',
  },
];

export const additionalServicesDE = [
  'Projekt-Management',
  'Business-Analyse',
  'UI/UX-Design',
  'Qualitätssicherung',
  'Cloud-Entwicklung',
  'IT-Sicherheit',
  'DevOps',
  'Architektonische Planung',
  'Marketing-Dienstleistungen',
];

export const additionalServices = [
  'Project Management',
  'Business Analysis',
  'UI/UX Design',
  'QA/QA Automation Engineer',
  'Cloud Development',
  'IT Security',
  'DevOps Engineer',
  'Marketing Services',
  'Architecture Planning',
];

export const projectStages = ['Idea', 'Prototype/Specification', 'Designed solution', 'MVP'];

export const projectStagesDe = ['Idee', 'Prototyp/Spezifikation', 'Gestaltete Lösung', 'MVP'];
